export default "//file.bilionpass.com/japandx-web/0.0.1/static/empty-coupon.3046a1d7-e1a099.svg";